import React from 'react';
import { NavLink } from 'react-router-dom';
import { companyData, trustElements } from '../data/content';
import { FiCheckCircle, FiAward, FiStar, FiUsers } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const About = () => {
  return (
    <div className="pt-0 pb-24 bg-white">
      {/* About Hero */}
      <div className="bg-ms-solar text-white py-24 lg:py-32 relative overflow-hidden">
        <div className="absolute inset-0 bg-brand-gradient opacity-90"></div>
        <div className="max-w-7xl mx-auto px-4 relative z-10 text-center">
          <h1 className="text-5xl lg:text-8xl font-black uppercase tracking-tighter mb-6">Über Uns</h1>
          <p className="text-xl lg:text-2xl text-white/80 max-w-2xl mx-auto font-medium">
            Qualität aus Heinsberg. Handwerk mit Leidenschaft.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-24">
        <div className="grid lg:grid-cols-2 gap-20 items-center mb-32">
          <div className="space-y-8">
            <span className="text-ms-red font-black uppercase tracking-[.3em] text-sm">Unsere Geschichte</span>
            <h2 className="text-4xl lg:text-6xl font-black text-ms-dark uppercase tracking-tighter leading-none">
              Meisterhandwerk aus der Region.
            </h2>
            <p className="text-xl text-ms-dark/70 leading-relaxed font-medium">
              Als lokales Unternehmen sind wir tief im <span className="text-ms-blue font-black">Kreis Heinsberg</span> verwurzelt. Wir verstehen die Bedürfnisse unserer Kunden hier vor Ort: Ehrlichkeit, Zuverlässigkeit und ein Ergebnis, das Jahrzehnte hält.
            </p>
            <div className="grid sm:grid-cols-2 gap-6 pt-4">
              <div className="p-6 bg-ms-light rounded-3xl border border-ms-blue/5">
                <SafeIcon icon={FiAward} className="text-3xl text-ms-blue mb-4" />
                <h4 className="font-black text-ms-dark uppercase tracking-tighter mb-2">Qualität</h4>
                <p className="text-xs font-bold text-ms-dark/60 uppercase">Höchste Materialstandards</p>
              </div>
              <div className="p-6 bg-ms-light rounded-3xl border border-ms-blue/5">
                <SafeIcon icon={FiUsers} className="text-3xl text-ms-blue mb-4" />
                <h4 className="font-black text-ms-dark uppercase tracking-tighter mb-2">Persönlich</h4>
                <p className="text-xs font-bold text-ms-dark/60 uppercase">Direktkontakt Chef</p>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="absolute -inset-6 bg-ms-red opacity-10 rounded-[3rem] rotate-3 animate-pulse"></div>
            <img 
              src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" 
              alt="Planung" 
              className="relative rounded-[2.5rem] shadow-2xl w-full border-4 border-white"
            />
          </div>
        </div>

        {/* Values */}
        <div className="bg-ms-dark rounded-[3.5rem] p-12 lg:p-24 text-white relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-ms-blue/10 rounded-full blur-3xl -mr-32 -mt-32"></div>
          <div className="relative z-10 grid lg:grid-cols-3 gap-16">
            <div className="lg:col-span-1">
              <h3 className="text-4xl font-black uppercase tracking-tighter mb-6">Unser Versprechen</h3>
              <div className="w-20 h-2 bg-ms-red mb-8"></div>
              <p className="text-lg text-white/60 font-medium italic">
                "Wir verlassen Ihre Baustelle erst, wenn Sie zu 100% zufrieden sind. Ihr Vertrauen ist unser Kapital."
              </p>
            </div>
            <div className="lg:col-span-2 grid sm:grid-cols-2 gap-8">
              {trustElements.map((item, i) => (
                <div key={i} className="flex items-center space-x-4">
                  <div className="bg-ms-blue/20 p-3 rounded-xl">
                    <SafeIcon icon={FiCheckCircle} className="text-ms-blue text-2xl" />
                  </div>
                  <span className="font-black uppercase tracking-widest text-xs">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;